import $ from 'jquery';

import BaseController from 'chairisher/_controller';
import CountryView from 'chairisher/view/account/countries';
import executeRecaptcha from 'chairisher/view/helper/recaptcha';
import FileUploader from 'chairisher/view/fileuploader';

import { getRecaptchaActionName } from 'chairisher/context/auth';
import { isAddressAutocompleteEnabled, isAddressVerificationEnabled } from 'chairisher/context/google';
import {
    AmplitudeEventProperty,
    TradePosition,
    logAmplitudeButtonClickEvent,
    logAmplitudeClickEvent,
    logScreenView,
    TrackingScreen,
} from 'chairisher/util/analytics';
import { handleAsyncError } from 'chairisher/util/logging';
import { countryCodes } from 'chairisher/context/location';

/**
 * Controller that binds actions for the trade register page
 */
class TradeRegisterController extends BaseController {
    bindPageAnalytics() {
        super.bindPageAnalytics();

        logScreenView(TrackingScreen.TRADE_REGISTER);

        $('.js-remind-cta').on('click', (e) => {
            const $link = $(e.currentTarget);
            logAmplitudeClickEvent($link.text().toLowerCase().trim(), TradePosition.REGISTER, $link.attr('href'));
        });

        $('.js-trade-enroll-submit-btn').on('click', ({ currentTarget }) => {
            const $btn = $(currentTarget);
            logAmplitudeButtonClickEvent($btn.data('amplitude-text').toLowerCase().trim(), {
                [AmplitudeEventProperty.CTA_POSITION]: TradePosition.REGISTER,
            });
        });
    }

    bindPageActions() {
        super.bindPageActions();

        const countryView = new CountryView({ $countryEl: $('.js-address-country') });
        countryView.bind();

        const $accountTradeForm = $('#account_trade_form').buttonLoadingHelper();
        const $addressFields = $accountTradeForm.find('.js-address-fields');

        if (isAddressAutocompleteEnabled()) {
            import('chairisher/component/autocomplete/google/address').then(
                ({ default: GoogleAutocompleteAddress }) => {
                    const googleAutocompleteAddress = new GoogleAutocompleteAddress({
                        $addressFields,
                        hasSingleStreetLine: true,
                    });
                    googleAutocompleteAddress.bind();
                },
                handleAsyncError,
            );
        }

        $accountTradeForm.on('submit', async (e) => {
            e.preventDefault();
            await executeRecaptcha(getRecaptchaActionName()).then(async () => {
                if (!isAddressVerificationEnabled()) {
                    e.target.submit();
                } else {
                    const { default: GoogleAddressVerification } = await import(
                        'chairisher/view/google/addressverification'
                    );
                    GoogleAddressVerification.triggerVerification({
                        $addressFields,
                        callback() {
                            e.target.submit();
                        },
                        hasSingleStreetLine: true,
                    });
                }
            }, handleAsyncError);
        });

        this.fileUploader = new FileUploader({
            $el: $('.js-file-uploader'),
            formData: [
                {
                    name: 'image_type',
                    value: 'T',
                },
            ],
        }).bind();

        // bind validation to ensure all required fields are filled out
        const $requiredFields = $accountTradeForm.find('[required]');

        $requiredFields.on('change', ({ currentTarget }) => {
            const $formGroup = $(currentTarget).closest('.js-form-group');
            $formGroup.removeClass('has-error');

            const $errors = $formGroup.find('.js-errors');
            $errors.html('');
        });

        // flip should_add_exemption form flag when the corresponding button is clicked.  Used by the destination
        // endpoint to figure out whether to display the tax exemption form.
        $('.js-should-add-exemption').on('click', () => {
            $('[name="should_add_exemption"]').val(1);
        });

        // show or hide business number field
        $('.js-address-country').on('focusout', () => {
            const addressCountryCode = $('.js-address-country').find('#id_country_code').val();
            if (addressCountryCode === countryCodes.ca) {
                $('.js-business-number').removeClass('hidden');
                $('.js-file-uploader').find('.help-text')[0].innerText =
                    'Upload your business license, reseller license, or other proof of business.';
            } else if (!$('.js-business-number').hasClass('hidden')) {
                $('.js-business-number').addClass('hidden');
                $('.js-file-uploader').find('.help-text')[0].innerText =
                    'Upload your EIN, business license, reseller' +
                    ' license, or other proof of business &mdash; tax exemption status will be determined separately.';
            }
        });
    }
}

export default TradeRegisterController;
